import { render } from "./AccountStatus.vue?vue&type=template&id=251a6ba2&scoped=true"
import script from "./AccountStatus.vue?vue&type=script&lang=js"
export * from "./AccountStatus.vue?vue&type=script&lang=js"

import "./AccountStatus.vue?vue&type=style&index=0&id=251a6ba2&scoped=true&lang=css"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-251a6ba2"]])

export default __exports__